<script>
    import BrandImage from "@xd/components/BrandImage";
    import BrandLink from "@xd/components/BrandLink";

    export default {
        name: "BrandProductDuffle",
        components: { BrandLink, BrandImage },
        props: {
            product: Object,
            visibleElements: Array,
        },
        methods: {
            checkElement(index) {
                return !this.visibleElements.includes(index.toString());
            },
        },
    };
</script>

<template>
    <div class="brand-product" :id="product.slug">
        <div class="l-container">
            <svg
                class="brand-product__line is-mobile"
                :class="{ 'is-animated': checkElement('line-mobile') }"
                data-name="line-mobile"
                width="343"
                height="498"
                viewBox="0 0 343 498"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M.906 35.468v461.997l340.838-201.371L269.937.783.906 35.468Z"
                    stroke="#000"
                    stroke-width=".5"
                />
            </svg>

            <svg
                class="brand-product__line is-desktop"
                :class="{ 'is-animated': checkElement('line-desktop') }"
                data-name="line-desktop"
                width="709"
                height="1033"
                viewBox="0 0 709 1033"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M.608 72.85v959l707.5-418L559.053.852.608 72.85Z" stroke="#000" />
            </svg>

            <header class="brand-product__header">
                <div
                    class="brand-product__title"
                    :class="{ 'is-animated': checkElement('title') }"
                    data-name="title"
                >
                    {{ product.title }}
                </div>
                <div
                    class="brand-product__date"
                    :class="{ 'is-animated': checkElement('date') }"
                    data-name="date"
                >
                    {{ product.date }}
                </div>
            </header>

            <div class="brand-product__body">
                <div class="brand-product__image image-1">
                    <brand-image
                        :image="product.image"
                        index="1"
                        :is-animated="checkElement('image-1')"
                        data-name="image-1"
                    ></brand-image>
                </div>

                <div class="brand-product__col">
                    <div class="brand-product__image image-2">
                        <brand-image
                            :image="product.image"
                            index="2"
                            :is-animated="checkElement('image-2')"
                            data-name="image-2"
                        ></brand-image>
                    </div>

                    <div
                        class="brand-product__text text-1"
                        :class="{ 'is-animated': checkElement('text-1') }"
                        data-name="text-1"
                        v-html="product.text[0]"
                    ></div>
                    <div
                        class="brand-product__text text-2"
                        :class="{ 'is-animated': checkElement('text-2') }"
                        data-name="text-2"
                        v-html="product.text[1]"
                    ></div>
                    <div
                        class="brand-product__text text-3"
                        :class="{ 'is-animated': checkElement('text-3') }"
                        data-name="text-3"
                        v-html="product.text[2]"
                    ></div>

                    <brand-link
                        class="brand-product__link"
                        :slug="product.slug"
                        :is-animated="checkElement('link')"
                        data-name="link"
                    ></brand-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .brand-product {
        padding: 100px 16px 10px;
        @include bp($bp-desktop-sm) {
            padding: 100px 0 150px;
        }
    }

    .brand-product__header {
        margin-bottom: 40px;
        text-align: right;
        @include bp($bp-desktop-lg) {
            flex-direction: row-reverse;
            margin-bottom: 80px;
        }
    }

    .brand-product__body {
        @include bp($bp-desktop-lg) {
            display: flex;
            flex-direction: row-reverse;
            margin: 0 -66px;
        }
    }

    .brand-product__col {
        @include bp($bp-desktop-lg) {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            margin: 0 66px;
        }
    }

    .brand-product__image {
        &.image-1 {
            width: calc(100% + 32px);
            margin-right: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 144.2%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 604px;
                margin: 0 66px;
            }
        }

        &.image-2 {
            margin-bottom: 40px;
            &::before {
                padding-bottom: 67.5%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 523px;
            }
        }
    }

    .brand-product__text {
        @include bp($bp-desktop-lg) {
            max-width: 475px;
        }
        &.text-1 {
            margin-bottom: 16px;
        }

        &.text-2 {
            margin-bottom: 16px;
        }

        &.text-3 {
            margin-bottom: 40px;
        }
    }

    .brand-product__link {
        @include bp($bp-desktop-lg) {
            margin-top: auto;
            margin-left: auto;
        }
    }

    .brand-product__line {
        top: -70px;
        right: -70px;
        stroke-dashoffset: 0;
        stroke-dasharray: 1434;
        transition: all 3s ease-in;
        animation-duration: 4s;
        animation-delay: 3.2s;
        &.is-animated {
            stroke-dashoffset: 1434;
        }
        @include bp($bp-desktop-lg) {
            top: -110px;
            right: -170px;
            stroke-dasharray: 2975;
            &.is-animated {
                stroke-dashoffset: 2975;
            }
        }
    }
</style>
